import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { Box, InputAdornment, TextField } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const DateRangePicker = (props) => {
    const {
        text, getSelectedDate, dateReset, style = {}, startDate1, endDate1, popperPlacement,
        // Was hardcoded to 2 below, so every caller passing monthsShown={1} was
        // silently getting a double-width calendar.
        monthsShown = 2,
        // Render the calendar into a portal at the document root. Needed wherever
        // an ancestor sets `overflow: hidden` (e.g. the Security pages' Card),
        // which would otherwise clip the popup. Opt-in so existing pages are
        // unaffected.
        portalId,
    } = props;
    const [startDate, setStartDate] = useState(startDate1 || null);
    const [endDate, setEndDate] = useState(endDate1 || null);
    const [showCalendar, setShowCalendar] = useState(false);

    const handleChange = (dates) => {
        const [start, end] = dates;
        getSelectedDate(dates);
        setStartDate(start);
        setEndDate(end);
        setShowCalendar(false);

    };

    useEffect(() => {
        if (typeof dateReset == "object" && Object?.keys(dateReset ?? {})?.length === 0) {
            setStartDate(null);
            setEndDate(null);
        }
    }, [dateReset])


    return (
        <div>
            <DatePicker
                selected={startDate}
                onChange={handleChange}
                startDate={startDate}
                endDate={endDate}
                selectsRange
                inline={showCalendar}
                monthsShown={monthsShown}
                placeholderText={text}
                dateFormat="dd/MM/yyyy"
                popperPlacement={popperPlacement}
                portalId={portalId}
                customInput={<CustomInput startDate={startDate} endDate={endDate} style={style} onClick={() => setShowCalendar(!showCalendar)} text={text} />}
            />

        </div>
    );
};
const CustomInput = ({ value, onClick, text }) => {
    const [focused, setFocused] = useState(false);
    const inputRef = useRef(null);

    return (
        <Box
            tabIndex={-1}
            sx={{
                position: 'relative',
                borderRadius: '8px',
                p: '2px',
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    borderRadius: 'inherit',
                    padding: '2px',
                    background: 'linear-gradient(90deg,rgba(255, 204, 112, 0.4) 0%, rgba(200, 80, 192, 0.4) 50%, rgba(65, 88, 208, 0.4) 100%)',
                    zIndex: 0,
                    opacity: focused ? 1 : 0,
                    transition: 'opacity 0.4s ease-in-out',
                },
                backgroundColor: '#fff',
                zIndex: 1,
            }}
            onClick={() => {
                setFocused(true);
                inputRef.current?.focus();
                onClick?.();
            }}
            onBlur={() => setFocused(false)}
        >
            <Box
                sx={{
                    borderRadius: '6px',
                    backgroundColor: '#fff',
                }}
            >
                <TextField
                    inputRef={inputRef}
                    fullWidth
                    value={value || text}
                    placeholder={text}
                    variant="outlined"
                    onBlur={() => setFocused(false)}
                    onFocus={() => setFocused(true)}
                    InputProps={{
                        readOnly: true,
                        endAdornment: (
                            <InputAdornment position="end">
                                <CalendarMonthIcon fontSize="small" />
                            </InputAdornment>
                        ),
                    }}
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '6px',
                            '& fieldset': {
                                border: '1px solid #CCCBCB',
                                transition: 'border 0.4s ease',
                            },
                            '&:hover fieldset': {
                                border: '1px solid #CCCBCB',
                                backgroundColor: 'rgba(238, 238, 238, 0.3)',
                                transition: 'background 0.4s ease',
                            },
                            '&.Mui-focused fieldset': {
                                border: '1px solid #CCCBCB',
                                transition: 'border 0.4s ease',
                            },
                        },
                        '& .Mui-focused': {
                            outline: 'none',
                        },
                    }}
                />
            </Box>
        </Box>
    );
};
export default DateRangePicker;
